import { routes } from "./routes";

const cityRestrictedRoutes = {
  "map-zipcode": [6, 10, 11],
};

export const superAdminOnlyRoutes = ["banner"];

export const isRouteAllowedForUser = ({ path }, isSuperAdmin) =>
  !!isSuperAdmin || !superAdminOnlyRoutes.includes(path);

export const isRouteVisibleForCity = ({ omit, path }, cityCode) => {
  if (omit) return false;
  const allowedCities = cityRestrictedRoutes[path];
  if (!allowedCities) return true;
  return allowedCities.includes(Number(cityCode));
};

export const getNavigationCommands = (cityCode, isSuperAdmin) =>
  routes
    .filter((route) => isRouteVisibleForCity(route, cityCode))
    .filter((route) => isRouteAllowedForUser(route, isSuperAdmin))
    .map((route) => ({
      id: route.to,
      name: route.name,
      section: route.section || "Otros",
      to: route.to,
      icon: route.icon,
      keywords: [route.name, route.section, route.path, route.to]
        .filter(Boolean)
        .join(" "),
      route,
    }));

export const groupNavigationCommands = (commands) => {
  const groups = new Map();
  commands.forEach((command) => {
    if (!groups.has(command.section)) groups.set(command.section, []);
    groups.get(command.section).push(command);
  });
  return groups;
};
